import {Panes, TextField} from '@management-ui/core';
import {InputAdornment} from '@mui/material';
import React from 'react';

const Fields = ({entity = {}, prefix = ''}) => {
  return (
    <Panes
      entity={entity}
      prefix={prefix}
      panes={[
        {
          title: '',
          fields: [
            <TextField
              name="weight"
              prefix={prefix}
              label="Weight"
              fieldProps={{
                InputProps: {
                  endAdornment: (
                    <InputAdornment position="end">
                      MT
                    </InputAdornment>
                  )
                }
              }}
            />
          ]
        }
      ]}
    />
  );
};

export default Fields;
